<template>
  <base-modal 
      icon-modal="info"
      modal-subtitle=""
      modal-title="Saved plan is no longer valid"
      text-confirm="New plan for same preferences"
      text-discard="Reset preferences"
      :closing-offered="false"
      :confirmation-disabled="false"
      :discarding-disabled="false"
      :confirmation-required="true"
      modal-name="SaveUnvalidModal"
      :close-on-confirm="true"
      :discarding-offered="true"
      :length="265"
      :body-gap="0"
      @confirm="newplan"
      @reject="reject"
  >
    <template #body >
      <p>
        Your saved plan is <strong>no longer valid</strong>.
        Do you want to compute a new plan based on the same preferences? Otherwise, you can also reset your preferences.
      </p>

    </template>
  </base-modal>
</template>


<script>
import { mapGetters, mapState } from 'vuex';
import BaseModal from "@/components/modals/BaseModal.vue";

export default {
  name: "SaveUnvalidModal",
  components: {BaseModal},
  props: {
    isOpen: Boolean,
    
  },
  computed: {
    ...mapGetters(['Preferences'],),
    ...mapState(["program","preferences", "violatedConstraints"]),
    sameSemester(){
      return this.preferences?.currentSemester === this.preferences?.savedSemester;
    },
    sameScheduleFeasible(){
      return this.violatedConstraints[0] != "Could not create the same schedule as previous one."
    }
    
  },
  data() {
   return {
  };
  },
  methods:{
    reject(){
      this.$store.commit('REDIRECT_TO_HOME');
    },
    newplan(){
      
      this.$store.dispatch("requestSchedule");
    }
  }
  
};
</script>

<style scoped>

</style>